import React from 'react';

import { formatPhone } from '../../../lib/helpers/phone.helpers';

interface IRsvpContactIdentityProps {
  name?: string;
  email?: string;
  phone?: string;
}

// One contact as a bold name followed by every credential on file, so the parent
// can tell which address or number this link could have reached them on.
export const RsvpContactIdentity: React.FC<IRsvpContactIdentityProps> = ({ name, email, phone }) => {
  const credentials = [email, formatPhone(phone)].filter(Boolean).join(' · ');

  // A contact with no name is identified by the credentials alone.
  if (!name) return <>{credentials}</>;

  return (
    <>
      <strong>{name}</strong>
      {credentials && ` · ${credentials}`}
    </>
  );
};
